<div class="wrap" id="regate">
  <div class="participation">
    <p>Participations</p>
    <hr>
  </div>
  <!-- <div class="loading" *ngIf="loading">
    <mat-spinner [diameter]="80"></mat-spinner>
  </div> -->
  <div class="content" *ngIf="!loading">
    <mat-accordion *ngIf="regates?.length && userIsLink ">
      <div *ngFor="let r of regates, let i = index" class="accordion">
        <div class="item">
          <mat-expansion-panel [expanded]="step === i" (opened)="setStep(i)">
            <mat-expansion-panel-header>
              <div class="title_mat_panel">
                <div class="epreuve">{{r.epreuve}}</div>
                <span>
                  <p>{{r.place | regateRang}}</p>
                </span>
              </div>
            </mat-expansion-panel-header>
            <div class="content_mat_panel">
              <div class="details">
                <h6>Détail de la régate</h6> <span>{{r.dateE_FIN | date}}</span>
              </div>
              <div class="content_mat_panel_infos">
                <p>Participants : {{r.nB_CLASSES}} </p>
                <p>Grade : {{r.grade}} </p>
              </div>
            </div>
          </mat-expansion-panel>
        </div>
      </div>
    </mat-accordion>

    <p *ngIf="!regates?.length && userIsLink ">Vous n'avez participé à aucune course</p>
    <p *ngIf="!regates?.length && !userIsLink ">Vous n'avez pas encore validé votre mail de
      confirmation pour avoir accès à vos informations. </p>
  </div>

  <app-skeleton-regates *ngIf="loading"></app-skeleton-regates>

</div>